// extracted by mini-css-extract-plugin
module.exports = {"backLink":"SettingsView_backLink__205Wk","heading":"SettingsView_heading__1fp_O","settingsView":"SettingsView_settingsView__1M7vR"};